import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { OrdersService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TOrder } from '@shared/models';
import { MyTimestampPipe } from '@shared/pipes';
import { MyCurrencyPipe } from '@shared/pipes';

@Component({
    'selector': 'app-users',
    'templateUrl': './orders.page.html',
    'styleUrls': ['./orders.page.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MyTimestampPipe,
        MyCurrencyPipe
    ]
})
export class OrdersPage extends ViewBasePage implements OnInit, OnDestroy {
    public orders: TOrder[] = [];

    constructor(private ordersService: OrdersService, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_ORDERS);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        const orders: TOrder[] = await this.ordersService.getAll();
        this.orders = this.ordersService.sort(orders, false);
        this.orders.forEach((order) => {
            // console.log('order = ', order);
            const items = order.items;
            // console.log('items = ', items);
            order.header.totalFormatted = this.utilsService.formatAsCurrency(order.header.total);
        });
        this.initMoreMenu();
    }

    public onOrderClick(order: TOrder) {
        // console.log(JSON.stringify(order));
        this.router.navigateByUrl(`/order/${order.uid}`);
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-orders-tour');
    }
}
